import { ServiceFieldType } from '@onlog-public/additional-services-types';
import { _optionsCacheCheckerAndLoaderProcessor } from '@pages/AdditionalServices/containers/services/optionsCacheCheckerAndLoader/types';
import optionsLoader from '@pages/AdditionalServices/containers/services/optionsLoader';
import { OptionsCache } from '@pages/AdditionalServices/containers/services/optionsLoader/types';

/**
 * EcoFeePackageProcessor реализует процессор загрузки упаковк экосбора
 * для полей дополнительных услуг
 */
export class EcoFeePackageProcessor implements _optionsCacheCheckerAndLoaderProcessor {
  /**
   * Возвращает тип поля, для которого реализован процессор.
   */
  GetType(): ServiceFieldType {
    return 'package';
  }

  /**
   * LoadCacheForNewData выполняет проверку, есть ли данные в кэше
   * и выполняет загрузку недостающих данных.
   *
   * @param _
   * @param existInStateKeys
   * @param loadingID
   */
  async LoadCacheForNewData(
    _: boolean,
    existInStateKeys: string[],
    loadingID?: string[]
  ): Promise<OptionsCache<any>> {
    if (!loadingID) {
      return { isPartialLoading: true, cache: {} };
    }

    const needLoad = loadingID.filter((c) => !existInStateKeys.includes(c)) ?? [];
    if (needLoad.length === 0) {
      return { isPartialLoading: true, cache: {} };
    }

    return optionsLoader().LoadOptionsCache('package', needLoad);
  }
}
